const villaTypeListObject = (payload) => {
  return {
    type: "villaTypeList",
    payload,
  };
};

export default villaTypeListObject;
